import React from "react";
import "./MofaBloreCert.css";
const MofaBloreCert = () => {
  return (
    <div className="mofaBloreCertContainer">
      <h2>
        MOFA <span>Attestation</span> in Bangalore for Certificate{" "}
      </h2>
      <p>
        MOFA attestation plays a role in the visa issuing procedure such as
        family or resident visa, employment visa, & others. You require a permit
        or a visa for taking admission in the school or for pursuing higher
        education or even for employment. It is done when you reach your
        destination country. The work permit or admission to foreign
        universities will be granted only after the MOFA attestation.
      </p>
      <ul>
        <p>
          UAE MOFA attestation in Bangalore: You need to get MOFA attestation
          from UAE for getting admission in UAE school or universities, or for
          getting a work permit in UAE. It is done for the authentication &
          verification of the documents.
        </p>
        <li>
          <span>Bahrain MOFA attestation in Bangalore : </span>MOFA attestation
          is the last verification process after the embassy attestation. For
          higher studies purpose or for a job, you need to get the MOFA
          attestation to prove the authenticity of the documents.
        </li>
        <li>
          <span>Qatar MOFA attestation in Bangalore : </span> MOFA attestation
          is required for getting work permits in Qatar. After embassy
          attestation, the documents are sent to MOFA for authentication &
          verification purpose.
        </li>
        <li>
          <span>Saudi MOFA attestation in Bangalore : </span>MOFA attestation is
          a compulsory requirement for getting work permit in Saudi. The Saudi
          government in detail verifies the documents. After the MOFA
          attestation, the work permit is only issued.
        </li>
        <li>
          <span>Kuwait MOFA attestation in Bangalore : </span>It is compulsory
          to get your documents attested from the Ministry of Foreign Affairs
          for the last verification purpose after embassy attestation.
        </li>
      </ul>
    </div>
  );
};

export default MofaBloreCert;
